import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tooltip,
  Box,
} from "@mui/material";
import { RentRollItem } from "../../../types/contract";
import GradientBorderAutocomplete from "./GradientBorderAutocomplete";

interface RentRollTableProps {
  rentRolls: RentRollItem[];
  propertyFilter: string;
  setRentRollPropertyFilter: (value: string) => void;
  roomFilter: string;
  setRentRollRoomFilter: (value: string) => void;
  lesseeFilter: string;
  setRentRollLesseeFilter: (value: string) => void;
  propertyOptions: string[];
  roomOptions: string[];
  lesseeOptions: string[];
}

export const RentRollTable: React.FC<RentRollTableProps> = ({
  rentRolls,
  propertyFilter,
  setRentRollPropertyFilter,
  roomFilter,
  setRentRollRoomFilter,
  lesseeFilter,
  setRentRollLesseeFilter,
  propertyOptions,
  roomOptions,
  lesseeOptions,
}) => (
  <TableContainer component={Paper}>
    <Table size="small" sx={{ tableLayout: "fixed" }}>
      <TableHead>
        <TableRow>
          {" "}
          {/* フィルターの行を一番上に移動 */}
          <TableCell sx={{ width: "20%", verticalAlign: "middle" }}>
            フィルター
          </TableCell>
          <TableCell sx={{ width: "20%", verticalAlign: "top" }}>
            <GradientBorderAutocomplete
              options={propertyOptions}
              inputValue={propertyFilter}
              onInputChange={(event, newInputValue) => {
                setRentRollPropertyFilter(newInputValue);
              }}
              label="物件名"
            />
          </TableCell>
          <TableCell sx={{ width: "20%", verticalAlign: "top" }}>
            <GradientBorderAutocomplete
              options={roomOptions}
              inputValue={roomFilter}
              onInputChange={(event, newInputValue) => {
                setRentRollRoomFilter(newInputValue);
              }}
              label="部屋名"
            />
          </TableCell>
          <TableCell sx={{ width: "20%", verticalAlign: "top" }}>
            <GradientBorderAutocomplete
              options={lesseeOptions}
              inputValue={lesseeFilter}
              onInputChange={(event, newInputValue) => {
                setRentRollLesseeFilter(newInputValue);
              }}
              label="入居者名"
            />
          </TableCell>
          <TableCell sx={{ width: "20%" }} /> {/* 書類の種類フィルターはなし */}
        </TableRow>
        <TableRow>
          {" "}
          {/* 元々のヘッダーの行 */}
          <TableCell sx={{ width: "20%" }}>ファイル名</TableCell>
          <TableCell sx={{ width: "20%" }}>物件名</TableCell>
          <TableCell sx={{ width: "20%" }}>部屋名</TableCell>
          <TableCell sx={{ width: "20%" }}>入居者名</TableCell>
          <TableCell sx={{ width: "20%" }}></TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {rentRolls.map((row, index) => (
          <TableRow key={index}>
            {[
              row.source_filename,
              row.property_name,
              row.room_name,
              row.lessee_name,
              "",
            ].map((text, cellIndex) => (
              <TableCell
                key={cellIndex}
                sx={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                <Tooltip title={text || ""} placement="bottom-start">
                  <Box
                    component="span"
                    sx={
                      cellIndex === 0 ? { color: "text.secondary" } : undefined
                    }
                  >
                    {(cellIndex === 0
                      ? (text || "").split(/[/／]/).pop()
                      : text) || ""}
                  </Box>
                </Tooltip>
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);